import type { JSX } from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router';
import { MarkdownLink } from '~/components/MarkdownLink';
import { generateProjectPath } from '~/lib/URLGenerators';
import ProjectHeaders, { ProjectHeadersProps } from '~/components/project-search/ProjectHeaders';

export type ProjectCardProps = {
  project: ProjectHeadersProps['project'] & { description?: string | null };
};

export default function ProjectCard({ project }: ProjectCardProps): JSX.Element {
  return (
    <div className="card mb-2">
      <div className="card-header d-flex">
        <div className="flex-grow-1 me-1">
          <ProjectHeaders project={project} />
        </div>
        <div>
          <Link to={generateProjectPath(project)} className="btn btn-secondary">
            View
          </Link>
        </div>
      </div>
      <div className="card-body">
        <ReactMarkdown components={{ a: MarkdownLink }}>
          {(project.description ?? '').slice(0, 500) +
            (project.description && project.description.length >= 500
              ? `[... (read more)](${generateProjectPath(project)})`
              : '')}
        </ReactMarkdown>
      </div>
    </div>
  );
}
